// @flow
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { compose } from 'react-recompose';
import ValidationService from '../../../../../lib/validation';
import SelectPreferredNumbers from './SelectPreferredNumbers';
import { fetchAvailablePhoneNumbers } from '../../../../../modules/SignUp/AvailablePhoneNumbers';

const validate = values => ({
  numbers: ValidationService.validatePreferredNumbers(values.numbers),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: form => {
    dispatch(fetchAvailablePhoneNumbers(form.numbers));
    ownProps.onRequestClose();
  },
});

export default compose(
  connect(undefined, mapDispatchToProps),
  reduxForm({ form: 'SelectPreferredNumbers', validate })
)(SelectPreferredNumbers);
